module.exports = __webpack_public_path__ + "static/img/vip.e60b72e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vip.png
// module id = 176
// module chunks = 1